module.exports = __webpack_public_path__ + "img/sent.c9361be2.gif";